export default __webpack_public_path__ + "static/media/Hair_9_M_C3.0c6e5297.svg";